"use strict";

exports.__esModule = true;
exports.createShortcutManager = void 0;
var _manager = require("./manager");
exports.createShortcutManager = _manager.createShortcutManager;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/shortcuts/index.js
// module id = 1602
// module chunks = 0